// Mock data for CleanRide Rental

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      vehicles: "Véhicules",
      pricing: "Tarifs",
      gallery: "Galerie",
      contact: "Contact"
    },
    hero: {
      title: "CleanRide Rental",
      subtitle: "Location de E-scooter, E-moto & Buggy",
      tagline: "Explorez Bora Bora en toute sérénité",
      cta: "Réserver maintenant"
    },
    vehicles: {
      title: "Nos Véhicules",
      subtitle: "Choisissez votre moyen de transport idéal pour explorer le paradis",
      scooter: {
        name: "E-Scooter",
        models: "Yadea E8S Pro / Keeway Hurricane 50",
        description: "Scooter moderne et élégant, disponible en version électrique ou thermique. Parfait pour les couples et les balades en solo.",
        features: ["Électrique ou thermique", "Facile à conduire", "Idéal pour 1-2 personnes", "Économique"]
      },
      moto: {
        name: "E-Moto",
        models: "Super Socco Tc max / Keeway Veracruz 125",
        description: "Moto puissante et confortable pour explorer Bora Bora avec style. Électrique ou thermique selon votre préférence.",
        features: ["Électrique ou thermique", "Puissante 125cc", "Confortable pour 2", "Grande autonomie"]
      },
      buggy: {
        name: "Buggy",
        models: "TrailBlazer 300",
        description: "Buggy tout-terrain TrailBlazer 300. L'aventure ultime pour les couples avec une expérience inoubliable!",
        features: ["300cc puissant", "2 places confortables", "Tout-terrain", "Toit de protection"]
      },
      learnMore: "En savoir plus"
    },
    pricing: {
      title: "Tarifs",
      subtitle: "Des prix transparents pour votre aventure à Bora Bora",
      perDay: "par 24h",
      promotion: "Promotion : 4 jours + 1 gratuit",
      bookNow: "Réserver"
    },
    gallery: {
      title: "Galerie",
      subtitle: "Découvrez la beauté de Bora Bora"
    },
    benefits: {
      title: "Pourquoi CleanRide?",
      subtitle: "Votre location en toute sérénité",
      payment: {
        title: "Paiement CB accepté",
        description: "Nous acceptons les paiements par carte bancaire pour votre confort"
      },
      insurance: {
        title: "Assurance comprise",
        description: "Véhicules assurés au tiers (minimal requis en Polynésie française). Tous nos prix incluent l'assurance!"
      },
      deposit: {
        title: "Pas de caution",
        description: "Aucune caution demandée. Seule votre pièce d'identité est nécessaire"
      },
      helmets: {
        title: "Casques inclus",
        description: "2 casques CleanRide fournis gratuitement avec chaque location"
      },
      gps: {
        title: "Traçage GPS",
        description: "3 puces GPS par véhicule (cadre, carrosserie et cachée) + GPS dans les casques. Sécurité maximale contre le vol et localisation en temps réel sur l'île."
      }
    },
    reviews: {
      title: "Avis Clients",
      subtitle: "Ce que nos clients disent de nous",
      seeMore: "Voir tous les avis sur Google",
      rating: "Note moyenne"
    },
    contact: {
      title: "Contact & Réservation",
      subtitle: "Contactez-nous via WhatsApp pour réserver votre véhicule",
      whatsappButton: "Réserver via WhatsApp",
      callUs: "Appelez-nous",
      locations: {
        title: "Nos Points de Retrait",
        vaitape: "Vaitape - Centre principal (Gratuit)",
        matira: "Matira - Plage (Livraison payante)",
        anau: "Anau - Village (Livraison payante)",
        faanui: "Faanui - Ville (Livraison payante)",
        deliveryNote: "Livraison payante disponible"
      }
    },
    footer: {
      about: "À Propos",
      aboutText: "CleanRide Rental est votre partenaire de confiance pour explorer Bora Bora de manière écologique et confortable.",
      quickLinks: "Liens Rapides",
      contactInfo: "Contact",
      followUs: "Suivez-nous",
      copyright: "© 2025 CleanRide Rental. Tous droits réservés."
    }
  },
  en: {
    nav: {
      home: "Home",
      vehicles: "Vehicles",
      pricing: "Pricing",
      gallery: "Gallery",
      contact: "Contact"
    },
    hero: {
      title: "CleanRide Rental",
      subtitle: "E-scooter, E-moto & Buggy Rental",
      tagline: "Explore Bora Bora with Complete Serenity",
      cta: "Book Now"
    },
    vehicles: {
      title: "Our Vehicles",
      subtitle: "Choose your ideal way to explore paradise",
      scooter: {
        name: "E-Scooter",
        models: "Yadea E8S Pro / Keeway Hurricane 50",
        description: "Modern and elegant scooter, available in electric or thermal version. Perfect for couples and solo rides.",
        features: ["Electric or thermal", "Easy to drive", "Perfect for 1-2 people", "Economical"]
      },
      moto: {
        name: "E-Moto",
        models: "Super Socco Tc max / Keeway Veracruz 125",
        description: "Powerful and comfortable motorcycle to explore Bora Bora in style. Electric or thermal according to your preference.",
        features: ["Electric or thermal", "Powerful 125cc", "Comfortable for 2", "Long range"]
      },
      buggy: {
        name: "Buggy",
        models: "TrailBlazer 300",
        description: "TrailBlazer 300 off-road buggy. The ultimate adventure for couples with an unforgettable experience!",
        features: ["Powerful 300cc", "2 comfortable seats", "Off-road", "Protection roof"]
      },
      learnMore: "Learn More"
    },
    pricing: {
      title: "Pricing",
      subtitle: "Transparent prices for your Bora Bora adventure",
      perDay: "per 24h",
      promotion: "Promotion: 4 days + 1 free",
      bookNow: "Book Now"
    },
    gallery: {
      title: "Gallery",
      subtitle: "Discover the beauty of Bora Bora"
    },
    benefits: {
      title: "Why CleanRide?",
      subtitle: "Your rental with complete peace of mind",
      payment: {
        title: "Credit Card accepted",
        description: "We accept credit card payments for your convenience"
      },
      insurance: {
        title: "Insurance included",
        description: "Vehicles insured with third-party coverage (minimum required in French Polynesia). All our prices include insurance!"
      },
      deposit: {
        title: "No deposit",
        description: "No deposit required. Only your ID is necessary"
      },
      helmets: {
        title: "Helmets included",
        description: "2 CleanRide helmets provided free with every rental"
      },
      gps: {
        title: "GPS Tracking",
        description: "3 GPS chips per vehicle (frame, body and hidden) + GPS in helmets. Maximum security against theft and real-time location tracking on the island."
      }
    },
    reviews: {
      title: "Customer Reviews",
      subtitle: "What our customers say about us",
      seeMore: "See all reviews on Google",
      rating: "Average rating"
    },
    contact: {
      title: "Contact & Reservation",
      subtitle: "Contact us via WhatsApp to book your vehicle",
      whatsappButton: "Book via WhatsApp",
      callUs: "Call us",
      locations: {
        title: "Our Pickup Locations",
        vaitape: "Vaitape - Main Center (Free)",
        matira: "Matira - Beach (Paid delivery)",
        anau: "Anau - Village (Paid delivery)",
        faanui: "Faanui - Town (Paid delivery)",
        deliveryNote: "Paid delivery available"
      }
    },
    footer: {
      about: "About",
      aboutText: "CleanRide Rental is your trusted partner to explore Bora Bora in an eco-friendly and comfortable way.",
      quickLinks: "Quick Links",
      contactInfo: "Contact",
      followUs: "Follow Us",
      copyright: "© 2025 CleanRide Rental. All rights reserved."
    }
  },
  es: {
    nav: {
      home: "Inicio",
      vehicles: "Vehículos",
      pricing: "Precios",
      gallery: "Galería",
      contact: "Contacto"
    },
    hero: {
      title: "CleanRide Rental",
      subtitle: "Alquiler de E-scooter, E-moto y Buggy",
      tagline: "Explora Bora Bora con total serenidad",
      cta: "Reservar ahora"
    },
    vehicles: {
      title: "Nuestros Vehículos",
      subtitle: "Elige tu forma ideal de explorar el paraíso",
      scooter: {
        name: "E-Scooter",
        models: "Yadea E8S Pro / Keeway Hurricane 50",
        description: "Scooter moderno y elegante, disponible en versión eléctrica o térmica. Perfecto para parejas y paseos en solitario.",
        features: ["Eléctrico o térmico", "Fácil de conducir", "Ideal para 1-2 personas", "Económico"]
      },
      moto: {
        name: "E-Moto",
        models: "Super Socco Tc max / Keeway Veracruz 125",
        description: "Motocicleta potente y cómoda para explorar Bora Bora con estilo. Eléctrica o térmica según tu preferencia.",
        features: ["Eléctrico o térmico", "Potente 125cc", "Cómoda para 2", "Gran autonomía"]
      },
      buggy: {
        name: "Buggy",
        models: "TrailBlazer 300",
        description: "Buggy todoterreno TrailBlazer 300. ¡La aventura definitiva para toda la familia con una experiencia inolvidable!",
        features: ["Potente 300cc", "4 plazas cómodas", "Todo terreno", "Techo de protección"]
      },
      learnMore: "Saber más"
    },
    pricing: {
      title: "Precios",
      subtitle: "Precios transparentes para tu aventura en Bora Bora",
      perDay: "por 24h",
      promotion: "Promoción: 4 días + 1 gratis",
      bookNow: "Reservar"
    },
    gallery: {
      title: "Galería",
      subtitle: "Descubre la belleza de Bora Bora"
    },
    benefits: {
      title: "¿Por qué CleanRide?",
      subtitle: "Tu alquiler con total tranquilidad",
      payment: {
        title: "Tarjeta de crédito aceptada",
        description: "Aceptamos pagos con tarjeta de crédito para tu comodidad"
      },
      insurance: {
        title: "Seguro incluido",
        description: "Vehículos asegurados a terceros (mínimo requerido en Polinesia Francesa). ¡Todos nuestros precios incluyen el seguro!"
      },
      deposit: {
        title: "Sin depósito",
        description: "No se requiere depósito. Solo es necesaria tu identificación"
      },
      helmets: {
        title: "Cascos incluidos",
        description: "2 cascos CleanRide proporcionados gratis con cada alquiler"
      },
      gps: {
        title: "Rastreo GPS",
        description: "3 chips GPS por vehículo (marco, carrocería y oculto) + GPS en cascos. Máxima seguridad contra robo y localización en tiempo real en la isla."
      }
    },
    reviews: {
      title: "Opiniones de Clientes",
      subtitle: "Lo que nuestros clientes dicen sobre nosotros",
      seeMore: "Ver todas las opiniones en Google",
      rating: "Puntuación media"
    },
    contact: {
      title: "Contacto y Reserva",
      subtitle: "Contáctenos por WhatsApp para reservar su vehículo",
      whatsappButton: "Reservar por WhatsApp",
      callUs: "Llámanos",
      locations: {
        title: "Nuestros Puntos de Recogida",
        vaitape: "Vaitape - Centro principal (Gratis)",
        matira: "Matira - Playa (Entrega pagada)",
        anau: "Anau - Pueblo (Entrega pagada)",
        faanui: "Faanui - Ciudad (Entrega pagada)",
        deliveryNote: "Entrega pagada disponible"
      }
    },
    footer: {
      about: "Acerca de",
      aboutText: "CleanRide Rental es tu socio de confianza para explorar Bora Bora de forma ecológica y cómoda.",
      quickLinks: "Enlaces Rápidos",
      contactInfo: "Contacto",
      followUs: "Síguenos",
      copyright: "© 2025 CleanRide Rental. Todos los derechos reservados."
    }
  },
  it: {
    nav: {
      home: "Home",
      vehicles: "Veicoli",
      pricing: "Prezzi",
      gallery: "Galleria",
      contact: "Contatti"
    },
    hero: {
      title: "CleanRide Rental",
      subtitle: "Noleggio E-scooter, E-moto e Buggy",
      tagline: "Esplora Bora Bora in totale serenità",
      cta: "Prenota Ora"
    },
    vehicles: {
      title: "I Nostri Veicoli",
      subtitle: "Scegli il tuo modo ideale per esplorare il paradiso",
      scooter: {
        name: "E-Scooter",
        models: "Yadea E8S Pro / Keeway Hurricane 50",
        description: "Scooter moderno ed elegante, disponibile in versione elettrica o termica. Perfetto per coppie e giri in solitaria.",
        features: ["Elettrico o termico", "Facile da guidare", "Ideale per 1-2 persone", "Economico"]
      },
      moto: {
        name: "E-Moto",
        models: "Super Socco Tc max / Keeway Veracruz 125",
        description: "Moto potente e confortevole per esplorare Bora Bora con stile. Elettrica o termica secondo le tue preferenze.",
        features: ["Elettrica o termica", "Potente 125cc", "Confortevole per 2", "Grande autonomia"]
      },
      buggy: {
        name: "Buggy",
        models: "TrailBlazer 300",
        description: "Buggy fuoristrada TrailBlazer 300. L'avventura definitiva per le coppie con un'esperienza indimenticabile!",
        features: ["Potente 300cc", "2 posti comodi", "Fuoristrada", "Tettuccio protettivo"]
      },
      learnMore: "Scopri di più"
    },
    pricing: {
      title: "Prezzi",
      subtitle: "Prezzi trasparenti per la tua avventura a Bora Bora",
      perDay: "per 24h",
      promotion: "Promozione: 4 giorni + 1 gratis",
      bookNow: "Prenota"
    },
    gallery: {
      title: "Galleria",
      subtitle: "Scopri la bellezza di Bora Bora"
    },
    benefits: {
      title: "Perché CleanRide?",
      subtitle: "Il tuo noleggio in totale serenità",
      payment: {
        title: "Carta di credito accettata",
        description: "Accettiamo pagamenti con carta di credito per la tua comodità"
      },
      insurance: {
        title: "Assicurazione inclusa",
        description: "Veicoli assicurati responsabilità civile (minimo richiesto in Polinesia Francese). Tutti i nostri prezzi includono l'assicurazione!"
      },
      deposit: {
        title: "Nessun deposito",
        description: "Nessun deposito richiesto. È necessaria solo la tua carta d'identità"
      },
      helmets: {
        title: "Caschi inclusi",
        description: "2 caschi CleanRide forniti gratuitamente con ogni noleggio"
      },
      gps: {
        title: "Tracciamento GPS",
        description: "3 chip GPS per veicolo (telaio, carrozzeria e nascosto) + GPS nei caschi. Massima sicurezza contro i furti e localizzazione in tempo reale sull'isola."
      }
    },
    reviews: {
      title: "Recensioni Clienti",
      subtitle: "Cosa dicono i nostri clienti di noi",
      seeMore: "Vedi tutte le recensioni su Google",
      rating: "Valutazione media"
    },
    contact: {
      title: "Contatti & Prenotazione",
      subtitle: "Contattaci via WhatsApp per prenotare il tuo veicolo",
      whatsappButton: "Prenota via WhatsApp",
      callUs: "Chiamaci",
      locations: {
        title: "I Nostri Punti di Ritiro",
        vaitape: "Vaitape - Centro principale (Gratuito)",
        matira: "Matira - Spiaggia (Consegna a pagamento)",
        anau: "Anau - Villaggio (Consegna a pagamento)",
        faanui: "Faanui - Città (Consegna a pagamento)",
        deliveryNote: "Consegna a pagamento disponibile"
      }
    },
    footer: {
      about: "Chi Siamo",
      aboutText: "CleanRide Rental è il tuo partner di fiducia per esplorare Bora Bora in modo ecologico e confortevole.",
      quickLinks: "Link Rapidi",
      contactInfo: "Contatti",
      followUs: "Seguici",
      copyright: "© 2025 CleanRide Rental. Tutti i diritti riservati."
    }
  },
  zh: {
    nav: {
      home: "首页",
      vehicles: "车辆",
      pricing: "价格",
      gallery: "画廊",
      contact: "联系"
    },
    hero: {
      title: "CleanRide Rental",
      subtitle: "电动滑板车、电动摩托车和越野车租赁",
      tagline: "在完全宁静中探索博拉博拉岛",
      cta: "立即预订"
    },
    vehicles: {
      title: "我们的车辆",
      subtitle: "选择您探索天堂的理想方式",
      scooter: {
        name: "电动滑板车",
        models: "Yadea E8S Pro / Keeway Hurricane 50",
        description: "现代优雅的滑板车，提供电动或热动版本。适合情侣和单人骑行。",
        features: ["电动或热动", "易于驾驶", "适合1-2人", "经济实惠"]
      },
      moto: {
        name: "电动摩托车",
        models: "Super Socco Tc max / Keeway Veracruz 125",
        description: "强大舒适的摩托车，让您时尚地探索博拉博拉岛。根据您的喜好选择电动或热动。",
        features: ["电动或热动", "强劲125cc", "2人舒适", "长续航"]
      },
      buggy: {
        name: "越野车",
        models: "TrailBlazer 300",
        description: "TrailBlazer 300越野车。情侣难忘冒险的终极体验！",
        features: ["强劲300cc", "2个舒适座位", "全地形", "保护顶棚"]
      },
      learnMore: "了解更多"
    },
    pricing: {
      title: "价格",
      subtitle: "博拉博拉岛冒险的透明价格",
      perDay: "每24小时",
      promotion: "促销：4天+1天免费",
      bookNow: "立即预订"
    },
    gallery: {
      title: "画廊",
      subtitle: "发现博拉博拉岛的美丽"
    },
    benefits: {
      title: "为什么选择CleanRide？",
      subtitle: "让您的租赁完全安心",
      payment: {
        title: "接受信用卡",
        description: "我们接受信用卡付款，方便您的使用"
      },
      insurance: {
        title: "含保险",
        description: "车辆已投保第三方责任险（法属波利尼西亚最低要求）。我们所有价格均包含保险！"
      },
      deposit: {
        title: "无需押金",
        description: "无需押金。只需要您的身份证件"
      },
      helmets: {
        title: "含头盔",
        description: "每次租赁免费提供2个CleanRide头盔"
      },
      gps: {
        title: "GPS追踪",
        description: "每辆车配备3个GPS芯片（车架、车身和隐藏）+ 头盔内置GPS。最大限度防止盗窃，岛上实时定位。"
      }
    },
    reviews: {
      title: "客户评价",
      subtitle: "客户对我们的评价",
      seeMore: "在Google上查看所有评价",
      rating: "平均评分"
    },
    contact: {
      title: "联系与预订",
      subtitle: "通过WhatsApp联系我们预订您的车辆",
      whatsappButton: "通过WhatsApp预订",
      callUs: "致电我们",
      locations: {
        title: "我们的取车地点",
        vaitape: "Vaitape - 主中心（免费）",
        matira: "Matira - 海滩（付费配送）",
        anau: "Anau - 村庄（付费配送）",
        faanui: "Faanui - 城镇（付费配送）",
        deliveryNote: "提供付费配送服务"
      }
    },
    footer: {
      about: "关于",
      aboutText: "CleanRide Rental是您以环保舒适的方式探索博拉博拉岛的值得信赖的合作伙伴。",
      quickLinks: "快速链接",
      contactInfo: "联系方式",
      followUs: "关注我们",
      copyright: "© 2025 CleanRide Rental. 保留所有权利。"
    }
  }
};

export const vehicles = [
  {
    id: 'scooter',
    type: 'scooter',
    price: 5000,
    priceFormatted: '5 000 XPF',
    models: ['Yadea E8S Pro', 'Keeway Hurricane 50'],
    image: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/eqr60zih_4B1F9BFA-57D7-44BC-9267-CF6AC4A388FF.png'
  },
  {
    id: 'moto',
    type: 'moto',
    price: 10000,
    priceFormatted: '10 000 XPF',
    models: ['Super Socco Tc max', 'Keeway Veracruz 125'],
    image: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/36ajfxqj_FECC283A-A7C5-4D0B-BF97-3566336644AD.png'
  },
  {
    id: 'buggy',
    type: 'buggy',
    price: 15000,
    priceFormatted: '15 000 XPF',
    models: ['TrailBlazer 300'],
    image: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/8g1jdnxt_C8390BBF-5508-452F-AD5D-CDBD15F59970.png'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/v08v64rf_64855C22-9A23-48DC-A66E-70614D5BCCC2.png',
    alt: 'CleanRide vehicles lineup - Scooter, Moto & Buggy'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/eqr60zih_4B1F9BFA-57D7-44BC-9267-CF6AC4A388FF.png',
    alt: 'Yadea E8S Pro à Bora Bora - 100% Électrique avec casques'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/36ajfxqj_FECC283A-A7C5-4D0B-BF97-3566336644AD.png',
    alt: 'Super Soco TC Max à Bora Bora - 100% Électrique avec casques'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/8g1jdnxt_C8390BBF-5508-452F-AD5D-CDBD15F59970.png',
    alt: 'TrailBlazer 300 Buggy à Bora Bora'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1580725869538-9b164c27c44f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxib3JhJTIwYm9yYXxlbnwwfHx8fDE3NzYwNjkxNjB8MA&ixlib=rb-4.1.0&q=85',
    alt: 'Bora Bora landscape'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1706461168280-da6986cd91ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxib3JhJTIwYm9yYXxlbnwwfHx8fDE3NzYwNjkxNjB8MA&ixlib=rb-4.1.0&q=85',
    alt: 'Bora Bora aerial view'
  }
];

export const locations = [
  {
    id: 'vaitape',
    name: 'Vaitape',
    coordinates: [-16.5004, -151.7506],
    address: 'Centre principal de Vaitape',
    isFree: true
  },
  {
    id: 'matira',
    name: 'Matira',
    coordinates: [-16.5383, -151.7247],
    address: 'Plage de Matira',
    isFree: false,
    delivery: true
  },
  {
    id: 'anau',
    name: 'Anau',
    coordinates: [-16.4833, -151.7667],
    address: 'Village d\'Anau',
    isFree: false,
    delivery: true
  },
  {
    id: 'faanui',
    name: 'Faanui',
    coordinates: [-16.4900, -151.7800],
    address: 'Ville de Faanui',
    isFree: false,
    delivery: true
  }
];

export const contactInfo = {
  phone: '+689 89 53 17 42',
  whatsapp: '68989531742',
  email: 'contact@cleanriderental.com',
  address: 'Bora Bora, Polynésie française',
  googleMapsUrl: 'https://share.google/gtsH9VVJklAYHmHJ1'
};

export const branding = {
  logo: 'https://customer-assets.emergentagent.com/job_cleanride-bora/artifacts/1g8lyxif_77976EE5-566C-4045-853B-A8FBC33944A2.png',
  name: 'CleanRide Rental',
  tagline: 'Explore Bora Bora en toute sérénité'
};
